export async function postGeneratorOpenAI({ userRole, prompt, generator }) {
  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
  const response = await fetch('/openaiapi', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrf || '',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin',
    body: JSON.stringify({ userRole, prompt, generator })
  });

  if (response.status === 402) {
    let payload = {};
    try {
      payload = await response.json();
    } catch {
      // ignore
    }
    return { limited: true, payload, response };
  }

  if (!response.ok) {
    const detail = await response.text().catch(() => '');
    return { error: true, detail, response };
  }

  const data = await response.json();
  return { data, response };
}

export function getPaywallController(element) {
  const root = element.closest('[data-controller~="generator-paywall"]');
  if (!root) return null;
  return window.Stimulus?.getControllerForElementAndIdentifier(root, 'generator-paywall');
}
